// extracted by mini-css-extract-plugin
module.exports = {"project-result":"_3aOdfjc","projectResult":"_3aOdfjc","image":"dq1VFV9"};